import { maxPrecision, parseDataPoints } from '@tableau/metrics-engine';
import { IMetricDataInfo } from '../models/IMetricInfo';
import { IMetricDataPoints } from '../../ts/ServerApi/types/IMetricDataList';

import { MetricsDataAction, MetricsDataActionTypes } from '../actions/MetricsDataActions';
import { Loadable } from '../../ts/models/Loadable';
import { notLoadedData } from '../selectors';
import { LoadableDataPointsById } from '../state/MetricsDataState';

export const metricsDataReducer = (
  state: LoadableDataPointsById = {},
  action?: MetricsDataAction
): LoadableDataPointsById => {
  switch (action?.type) {
    case MetricsDataActionTypes.REQUEST_START: {
      const stateToAdd: LoadableDataPointsById = {};
      const idsToLoad = notLoadedData(state, action.ids);
      idsToLoad.forEach((id) => {
        stateToAdd[id] = Loadable.loading({});
      });
      return { ...state, ...stateToAdd };
    }
    case MetricsDataActionTypes.REQUEST_SUCCEEDED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.dataPointsById).forEach(([key, value]) => {
        stateToAdd[key] = Loadable.loaded(parseResponse(value));
      });
      return { ...state, ...stateToAdd };
    }
    case MetricsDataActionTypes.REQUEST_FAILED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.failuresById).forEach(([key, value]) => {
        stateToAdd[key] = Loadable.failed(value.message, undefined);
      });
      return { ...state, ...stateToAdd };
    }
    case MetricsDataActionTypes.CLEAR: {
      return {};
    }
    case undefined:
    default:
      return state;
  }
};

const parseResponse = (input: IMetricDataPoints): IMetricDataInfo => {
  return {
    dataPoints: parseDataPoints(input.points, maxPrecision(input.schema?.measure?.format)),
    schema: input.schema,
    dataRefreshedTimestamp: input.dataRefreshedTimestamp,
  };
};
